// @flow
import _ from 'lodash';

import ApiManager from './ApiManager';

import ApiRestaurant from './ApiRestaurant';
import ApiRole from './ApiRole';
import ApiRestaurantsGroup from './ApiRestaurantsGroup';

import ProRoleApiErrors from '../utils/apiErrors/ProRoleApiErrors';

// -- constants
import APIEndpoints from '../constants/APIEndpoints';

// -- entities
import ApiError from '../entities/ApiError';
import SessionStore from "../../../scripts/stores/SessionStore"

import {
  ProAccount,
  ProAccountsList,
  ProRole,
  ProPermission,
  ProPermissionsList,
  ProDomainsList,
  ProDomain,
} from '../entities/security';

import RestaurantsGroup from '../entities/restaurantsGroup';
import Restaurant from '../entities/Restaurant';

class ApiProAccount {
  static getRecoverPassword(email, success, failure) {
    ApiManager.get({
      endpoint: APIEndpoints.PRO_FORGOT_PASSWORD,
      query: {
        email,
      },
      success: json => {
        success(json);
      },
      failure: apiError => {
        failure(apiError);
      },
    });
  }

  static postAccount(
    account: ProAccount,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.PRO_ACCOUNTS;

    const requestOptions = {
      endpoint,
      data: account,
      success: (json: Object) => {

        const proAccount: ProAccount = new ProAccount();
        proAccount.fromJson(json);

        success(proAccount);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.post(requestOptions);
  }

  static getMeAccount(success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ME_ACCOUNT;

    const requestOptions = {
      endpoint,
      query: {},
      success: (json: Object) => {

        const proAccount: ProAccount = new ProAccount();
        proAccount.fromJson(json);

        success(proAccount);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  static getAccountData(
    defaultDomainId: string,
    defaultRestaurantId: string,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.PRO_ME_ACCOUNT_DOMAINS;


    //
    // Load account domains
    //
    const requestOptions = {
      endpoint,
      query: {
        loadProRole: true,
        loadRestaurantsGroup: true,
        loadRestaurantsGroupChildren: true,
      },
      success: (json: Object) => {
        const domainsList: ProDomainsList = new ProDomainsList();
        domainsList.fromJson(json);


        if (_.isEmpty(domainsList)) {
          // TODO: tell the user to fuck off.
          alert('Votre compte est désactivé');
          SessionStore.logout()
          window.location.pathname = "/login"
          return failure(null);
        }

        let domainId = defaultDomainId;

        let domain: ProDomain;
        if (_.isNull(domainId)) {
          domain = domainsList.domains[0];

          if (_.isNull(domain)) {
            // TODO: error at login, no domains.
            failure(null);
          }
        } else {
          domain = domainsList.getDomainWithId(domainId);

          if (_.isNull(domain)) {
            domain = domainsList.domains[0];
          }
        }

        const restaurantsGroupId = domain.restaurantsGroupId;

        //
        // Load me account
        //

        ApiProAccount.getMeAccount(
          (proAccount: ProAccount) => {

            proAccount.domainsList = domainsList;

            //
            // Load restaurantsGroup
            //

            ApiRestaurantsGroup.getRestaurantsGroupWithDomain(
              restaurantsGroupId,
              domain,
              true,
              (restaurantsGroup: RestaurantsGroup) => {
                if (_.isEmpty(restaurantsGroup.restaurantsIds)) {
                  // TODO: tell the user to fuck off.
                }

                proAccount.restaurantsGroup = restaurantsGroup;

                let restaurantId = defaultRestaurantId;

                if (_.isNil(restaurantId)) {
                  restaurantId = restaurantsGroup.restaurantsIds[0];
                }

                // find restaurantId on restaurantsGroup, otherwise use a default restaurantId.
                if (!restaurantsGroup.haveRestaurantWithId(restaurantId)) {
                  restaurantId = restaurantsGroup.restaurantsIds[0];
                }

                //
                // Load restaurant
                //

                ApiRestaurant.getRestaurantWithDomain(
                  restaurantId,
                  domain.id,
                  (restaurant: Restaurant) => {

                    ApiRole.getRoleWithDomain(
                      domain.roleId,
                      domain.id,
                      (proRole: ProRole) => {

                        proAccount.role = proRole;
                        domain.role = proRole;
                        domain.restaurantsGroup = restaurantsGroup;


                        success(proAccount, restaurant, domain);
                      },

                      (apiError: ApiError) => {
                        failure(apiError);
                      }
                    );
                  },
                  (apiError: ApiError) => {
                    failure(apiError);
                  }
                );
              },
              (apiError: ApiError) => {
                failure(apiError);
              }
            );
          },
          (apiError: ApiError) => {
            failure(apiError);
          }
        );
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  static getAccount(accountId: string, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ACCOUNT.replace(':accountId', accountId);

    const requestOptions = {
      endpoint,
      query: {},
      success: (json: Object) => {

        const proAccount: ProAccount = new ProAccount();
        proAccount.fromJson(json);

        success(proAccount);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  static putAccount(account: ProAccount, success: Function, failure: Function) {
    const endpoint = APIEndpoints.PRO_ACCOUNT.replace(':accountId', account.id);

    const requestOptions = {
      endpoint,
      data: account,
      success: (json: Object) => {
        const proAccount: ProAccount = new ProAccount();
        proAccount.fromJson(json);

        success(proAccount);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.put(requestOptions);
  }

  static deleteAccount(
    account: ProAccount,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.PRO_ACCOUNT.replace(':accountId', account.id);

    const requestOptions = {
      endpoint,
      success: (json: Object) => {
        success(account);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.delete(requestOptions);
  }

  static getAccountDomains(
    account: ProAccount,
    loadRole: boolean,
    loadRestaurantsGroup: boolean,
    loadRestaurantsGroupChildren: boolean,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.PRO_ACCOUNT_DOMAINS.replace(
      ':accountId',
      account.id
    );

    const requestOptions = {
      endpoint,
      query: {
        loadProRole: loadRole,
        loadRestaurantsGroup,
        loadRestaurantsGroupChildren,
      },
      success: (json: Object) => {
        const domainsList: ProDomainsList = new ProDomainsList();
        domainsList.fromJson(json);

        success(account, domainsList);
      },
      failure: (apiError: ApiError) => {
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }

  //
  // Get roles with code
  //

  static getProRoleWithElevationCode(
    proDomainId: string,
    elevationCode: string,
    success: Function,
    failure: Function
  ) {
    const endpoint = APIEndpoints.PRO_DOMAIN_ROLE.replace(
      ':domainId',
      proDomainId
    );

    const requestOptions = {
      endpoint,
      query: {},
      headers: {
        'pro-elevation-code': elevationCode,
      },
      success: (json: Object) => {
        const proRole: ProRole = new ProRole();
        proRole.fromJson(json);

        success(proRole, elevationCode);
      },
      failure: (apiError: ApiError) => {
        apiError.localizedMessage = ProRoleApiErrors.getOne(apiError);
        failure(apiError);
      },
    };

    ApiManager.get(requestOptions);
  }
}

export default ApiProAccount;



// WEBPACK FOOTER //
// ./sdk/scripts/api/ApiProAccount.js